export default Object.freeze({
  VERYEASY: 1,
  EASY: 2,
  NORMAL: 3,
  HARD: 4,
  VERYHARD: 5,
  properties: {
    1: { label: 'Very Easy', value: 1, code: 'VERYEASY' },
    2: { label: 'Easy', value: 2, code: 'EASY' },
    3: { label: 'Normal', value: 3, code: 'NORMAL' },
    4: { label: 'Hard', value: 4, code: 'HARD' },
    5: { label: 'Very Hard', value: 5, code: 'VERYHARD' }
  }
})



// WEBPACK FOOTER //
// ./src/lib/CardDifficulty.js